export default {
  txt: "txt",
  date: "date",
  number: "number",
  numberWithCommas: "numberWithCommas",
  selectRange: "selectRange",
  selectOptions: "selectOptions",
  textarea: "textarea",
  checkbox: "checkbox",
  radio: "radio",
  longList: "longList",
  radioValues: "radioValues"
};
